import React from 'react';

export const HardDriveIcon = ({
  width = '40',
  height = '40',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M36.6668 20.0013H3.3335M36.6668 20.0013V30.0013C36.6668 30.8854 36.3156 31.7332 35.6905 32.3583C35.0654 32.9834 34.2176 33.3346 33.3335 33.3346H6.66683C5.78277 33.3346 4.93493 32.9834 4.30981 32.3583C3.68469 31.7332 3.3335 30.8854 3.3335 30.0013V20.0013M36.6668 20.0013L30.9168 8.51797C30.6409 7.96261 30.2155 7.49525 29.6884 7.16843C29.1614 6.84162 28.5536 6.6683 27.9335 6.66797H12.0668C11.4467 6.6683 10.8389 6.84162 10.3119 7.16843C9.78487 7.49525 9.35946 7.96261 9.0835 8.51797L3.3335 20.0013M10.0002 26.668H10.0168M16.6668 26.668H16.6835"
      stroke="#3966E0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
